<template>
  <Card style="width:100%;overflow-x: hidden;margin-top: 10px">
  <div >

    <div class="myModal">
      <Form ref="artInfo"  :model='artInfo' label-position="right" :label-width="100" :rules="ruleValidate" @submit.native.prevent>
        <div class="topss">
        <div style="width: 100%;font-size: 20px;line-height: 40px"> 用户端APP更新</div>
        <form-item label="版本名名称" >
          <Input placeholder="请输入" v-model="artInfo.edition_name"></Input>
        </form-item>
        <form-item label="更新内容" >
          <Input placeholder="请输入" v-model="artInfo.describe" type="textarea"></Input>
        </form-item>

        <form-item label="是否强更新" >

          <RadioGroup v-model="artInfo.edition_force">
            <Radio label='1' >是</Radio>
            <Radio label='0' >否</Radio>
          </RadioGroup>
        </form-item>
        <form-item label="版本号" >
          <Input placeholder="请输入" v-model="artInfo.edition_number"></Input>
        </form-item>
          <form-item label="安装包路径" >
            <Input placeholder="请输入" v-model="artInfo.edition_url"></Input>
          </form-item>
        <form-item label="是否发行">
          <RadioGroup v-model="artInfo.edition_issue">
            <Radio label='1' >是</Radio>
            <Radio label='0' >否</Radio>
          </RadioGroup>
        </form-item>
        </div>
      <div class="topss">
        <div style="width: 100%;font-size: 20px;line-height: 40px"> 骑手端APP更新</div>
        <form-item label="版本名名称" >
          <Input placeholder="请输入" v-model="artInfo.rider_edition_name"></Input>
        </form-item>
        <form-item label="更新内容" >

          <Input placeholder="请输入" v-model="artInfo.rider_describe" type="textarea"></Input>
        </form-item>
        <form-item label="是否强更新" >
          <RadioGroup v-model="artInfo.rider_edition_force">
            <Radio label='1' >是</Radio>
            <Radio label='0' >否</Radio>
          </RadioGroup>
        </form-item>
        <form-item label="版本号" >
          <Input placeholder="请输入" v-model="artInfo.rider_edition_number"></Input>
        </form-item>
        <form-item label="安装包路径" >
          <Input placeholder="请输入" v-model="artInfo.rider_edition_url"></Input>
        </form-item>
        <form-item label="是否发行">
          <RadioGroup v-model="artInfo.rider_edition_issue">
            <Radio label='1' >是</Radio>
            <Radio label='0' >否</Radio>
          </RadioGroup>
        </form-item>
      </div>
      </Form>
    </div>

    <div slot="footer" style="clear: both">
      <Button type="primary"   @click="handleOk('artInfo')">确定</Button>
    </div>
  </div>
  </Card>
</template>
<style>
  .topss{
    width: 35%;
    float: left;
    margin-left: 3%;
  }
  .myModal {
    margin-left: 20px;
    margin-top: 20px;
  }

  .demo-upload-list{
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: block;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }

</style>
<script>
  import { Info, edit } from '@/api/renew'
  import ueditor from '@/components/ueditorFrom/index'
  import Setting from '@/setting'
  export default {
    name: 'listEdit',
    components: { ueditor },
    props: ['editShow', 'id'],
    data () {
      return {
        server_url: Setting.serverSrc,
        serverApiPic: Setting.serverApiPic,
        serverApiFile: Setting.serverApiFile,
        uploadList: [], // logo
        visible: false,
        imgUrl: '',
        title: 'app热更新',
        editor: null,
        isShow: false,
        article_id: 0,
        artInfo: {
          edition_name:'',
          describe:'',
          edition_force:'',
          edition_number:'',
          edition_issue:'',
          edition_url:'',
          rider_edition_name:'',
          rider_describe:'',
          rider_edition_force:'',
          rider_edition_number:'',
          rider_edition_url:'',
          rider_edition_issue:'',
        },
        delpics:[],
        ruleValidate: {
          title: [
            { required: true, message: '请输入标题', trigger: 'blur' }
          ]
        }
      }
    },
    created () {

      this.articleInfo()
    },
    methods: {
      handle (status) {
        this.$emit('updateStatusModel', false)
      },
      handleOk (name) {
        // this.artInfo.title = this.$refs.ueDetail.contents
        let data = this.artInfo
        edit(data).then(res => {
          let msg = '修改成功'
          if (res.code === 200) {
            this.$Message.success(msg)
            this.$router.push({ path: '/admin/system/renew' })
          } else {
            this.$Message.error(res.msg)
          }
        }).catch(res => {
          this.$Message.error(res.msg)
        })


      },
      articleInfo () {
        Info(1).then(res => {
          // console.log(res)
          this.artInfo = res.data
          // this.uploadList.push({ 'url': this.artInfo.pic, 'showProgress': false, 'percentage': 100, 'status': 'finished' })//
          // this.$refs.ueDetail.contents = this.artInfo.content
          // this.title = this.artInfo.title
        }).catch(res => {
          this.$Message.error(res.msg)
        })
      },
      handleView (url) {
        this.imgUrl = url
        this.artInfo.pic = url
        this.visible = true
      },
      // logo删除
      handleRemove (file) {
        const fileList2 = this.uploadList
        this.delpics.push(file.url)
        this.uploadList.splice(fileList2.indexOf(file), 1)
        this.uploadList = []
      },
      // logo
      handleSuccess (res, file) {
        file.url = res.data.file_url
        this.uploadList = this.$refs.uploadThumb.fileList
      },
      handleFormatError (file) {
        this.$Message.error('文件' + file.name + '格式错误，请上传jpg或者png')
      },
      handleMaxSize (file) {
        this.$Message.error('文件' + file.name + '太大，不能大于10M')
      },
      // 缩略图
      handleBeforeUpload () {
        const check = this.uploadList.length < 1
        if (!check) {
          this.$Message.error('只能上传1张图片')
        }
        return check
      },

    }
  }
</script>
